import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    transactions: {
      id: 'pages.transactionView.breadcrumbs.transactions',
      defaultMessage: 'Transactions',
      description: 'label of the breadcrumb transactions on the transaction view page',
    },
  },
  secondaryActions: {
    refund: {
      id: 'pages.transactionView.secondaryActions.refund',
      defaultMessage: 'Refund',
      description: 'label of the refund action on the transaction view page',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.transactionView.subNavigation.details',
      defaultMessage: 'Details',
      description: 'label of the details tab on the transaction view page',
    },
    logs: {
      id: 'pages.transactionView.subNavigation.logs',
      defaultMessage: 'Logs',
      description: 'label of the logs tab on the transaction view page',
    },
  },
  feedback: {
    paymentRefunded: {
      id: 'pages.transactionView.feedback.paymentRefunded',
      defaultMessage: 'Payment has been refunded',
      description: 'feedback on the successful refund on the transaction view page',
    },
    paymentNotRefunded: {
      id: 'pages.transactionView.feedback.paymentNotRefunded',
      defaultMessage: 'Payment could not be refunded',
      description: 'feedback on a failed refund on the transaction view page',
    },
  },
  confirmRefund: {
    title: {
      id: 'pages.transactionView.confirmRefund.title',
      defaultMessage: 'Refund payment',
      description: 'title on the confirmation of refund on the transaction view page',
    },
    description: {
      id: 'pages.transactionView.confirmRefund.description',
      defaultMessage: 'Are you sure you want to refund this payment?',
      description: 'description on the confirmation of refund on the transaction view page',
    },
    actions: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'label of the cancel action',
      },
      refund: {
        id: 'actions.refund',
        defaultMessage: 'Refund',
        description: 'label of the refund action',
      },
    },
  },
  confirmExecuteRefund: {
    title: {
      id: 'pages.transactionView.confirmExecuteRefund.title',
      defaultMessage: 'Refund or park',
      description:
        'title on the confirmation of the execution of the refund on the transaction view page',
    },
    description: {
      id: 'pages.transactionView.confirmExecuteRefund.description',
      defaultMessage: 'Do you want to execute the refund or park it for later?',
      description:
        'description on the confirmation of the execution of the refund on the transaction view page',
    },
    actions: {
      park: {
        id: 'actions.park',
        defaultMessage: 'Park',
        description: 'label of the park action',
      },
      execute: {
        id: 'actions.refund',
        defaultMessage: 'Refund',
        description: 'label of the refund action',
      },
    },
  },
};

export default defineMessages(translations);
